<div class="hidden">
  <ejs-grid #hospitalsGrid [dataSource]="gridData" allowExcelExport="true"
    (excelQueryCellInfo)="onExcelQueryCellInfo($event)"
  >
    <e-columns>
      <e-column field="onekey" headerText="CODICE ONEKEY" width="150"></e-column>
      <e-column field="cluster" headerText="CLUSTER" width="100" textAlign="Center"></e-column>
      <e-column field="hospitalName" headerText="OSPEDALE" width="310"></e-column>
      <e-column field="city" headerText="CITTÀ" width="180"></e-column>
      <e-column field="accountType" headerText="TIPOLOGIA" width="180"></e-column>
      <e-column field="potentialNumber" headerText="ESPERIENZE #" width="160" textAlign="Center"></e-column>
      <e-column field="italyPercentage" headerText="PESO IN ITALIA %" width="140" textAlign="Center"></e-column>
      <e-column field="hospitalNote" headerText="NOTE" width="400"></e-column>
    </e-columns>
  </ejs-grid>
</div>